import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let PiButton = class PiButton extends Vue {
    get className() {
        let className = this.btnType == "text" ? "pi-button-text " : "pi-button ";
        if (this.type) {
            className += this.type + " ";
        }
        if (this.size) {
            className += this.size + " ";
        }
        if (this.disabled || this.disabled === "") {
            className += "disable ";
        }
        if (this.loading || this.loading === "") {
            className += "pi-but-loading ";
        }
        if (this.borderStyle) {
            className += "pi-border-" + this.borderStyle + " ";
        }
        return className;
    }
    btnClick() {
        if (!this.disabled && !this.loading) {
            this.$emit("click");
        }
    }
};
__decorate([
    Prop({ default: "" })
], PiButton.prototype, "btnType", void 0);
__decorate([
    Prop({ default: "default" })
], PiButton.prototype, "type", void 0);
__decorate([
    Prop({ default: "small" })
], PiButton.prototype, "size", void 0);
__decorate([
    Prop({ default: "" })
], PiButton.prototype, "icon", void 0);
__decorate([
    Prop({ default: "before" })
], PiButton.prototype, "iconPosition", void 0);
__decorate([
    Prop({ default: "" })
], PiButton.prototype, "borderStyle", void 0);
__decorate([
    Prop({ default: false })
], PiButton.prototype, "disabled", void 0);
__decorate([
    Prop({ default: false })
], PiButton.prototype, "loading", void 0);
PiButton = __decorate([
    Component
], PiButton);
export default PiButton;
